import {
  MDSIconButton,
  MDSIconButtonSize,
  MDSIconButtonVariant,
  MDSIconKind,
  MDSTooltip,
  MDSTooltipPlacement,
} from "@/mds";
import { getShortcutTooltipConfig } from "@/modules/keyboard-shortcuts/tooltip";

type TProps = {
  navigateBack: () => void;
  navigateForward: () => void;
  canNavigateBack: boolean;
  canNavigateForward: boolean;
};

export const BackForwardButtons = ({
  navigateBack,
  navigateForward,
  canNavigateBack,
  canNavigateForward,
}: TProps) => {
  return (
    <>
      <MDSTooltip
        config={getShortcutTooltipConfig({
          action: "go_back",
          label: "Go back",
          placement: MDSTooltipPlacement.Top,
        })}
      >
        <MDSIconButton
          variant={MDSIconButtonVariant.OnChrome}
          size={MDSIconButtonSize.Medium}
          iconKind={MDSIconKind.LeftArrow}
          onClick={navigateBack}
          isDisabled={!canNavigateBack}
        />
      </MDSTooltip>
      <MDSTooltip
        config={getShortcutTooltipConfig({
          action: "go_forward",
          label: "Go forward",
          placement: MDSTooltipPlacement.Top,
        })}
      >
        <MDSIconButton
          variant={MDSIconButtonVariant.OnChrome}
          size={MDSIconButtonSize.Medium}
          iconKind={MDSIconKind.RightArrow}
          onClick={navigateForward}
          isDisabled={!canNavigateForward}
        />
      </MDSTooltip>
    </>
  );
};
